// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__ADvod","skills__label":"Skills_skills__label__S78lj","skills__list":"Skills_skills__list__2nTMg"};